<div mat-dialog-content>
  <div class="mat-dialog-content">
    @if (model) {
      <form class="form" [formGroup]="model" id="fees-procedure-form" (ngSubmit)="submit()">
        <div class="body-modal">
          <div class="title-header">
            <h1>Procedimentos Executados</h1>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 col-md-2">
              <mat-form-field appearance="outline">
                <mat-label>36 - Data</mat-label>
                <input matInput type="text" [mask]="masks.date" formControlName="procedureDate">
                @if (model.get('procedureDate').invalid) {
                  <mat-error>Preenchimento
                  incorreto</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-2">
              <mat-form-field appearance="outline">
                <mat-label>37 - Hora inicial</mat-label>
                <input matInput type="text" [mask]="masks.fullTime.mask"
                  formControlName="procedureStartDatetime">
                  @if (model.get('procedureStartDatetime').invalid) {
                    <mat-error>Preenchimento
                    incorreto</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-12 col-sm-6 col-md-2">
                <mat-form-field appearance="outline">
                  <mat-label>38 - Hora Final</mat-label>
                  <input matInput type="text" [mask]="masks.fullTime.mask"
                    formControlName="procedureEndDatetime">
                    @if (model.get('procedureEndDatetime').invalid) {
                      <mat-error>Preenchimento
                      incorreto</mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-5">
                  <mat-form-field appearance="outline">
                    <mat-label>39 - Tabela</mat-label>
                    <mat-select formControlName="idTerminologyGroup" (selectionChange)="selectTable()">
                      @for (item of tussTerminologyGroupMap | keyvalue; track item) {
                        <mat-option
                          [value]="item.value.idTerminologyGroup" [disabled]="item.value.idTerminologyGroup !== procedimentos">{{item.value.terminologyGroupCode}} -
                          {{item.value.nameTerminologyGroup}}
                        </mat-option>
                      }
                    </mat-select>
                    @if (model.get('idTerminologyGroup').invalid && !model.get('idTerminologyGroup').errors?.maxlength) {
                      <mat-error
                        >Preenchimento
                      incorreto</mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-6">
                  <mat-form-field appearance="outline">
                    <mat-label>40/41 - Cód. do procedimento/Descrição</mat-label>
                    <mat-select formControlName="procedure" (selectionChange)="selectProcedure($event.value)">
                      <input class="inputSearchSelect" type="text" (keyup)="onKey($event.target.value)"
                        placeholder="Pesquisar" autocomplete="off" (keydown)="$event.stopPropagation()">
                        @for (item of listProcedure; track item) {
                          <mat-option
                            [value]="item">{{item.terminology.terminologyCode}} -
                            {{item.terminology.terminologyName}}
                          </mat-option>
                        }
                      </mat-select>
                      @if (model.get('procedure').invalid) {
                        <mat-error>Preenchimento incorreto</mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-4 col-md-3">
                    <mat-form-field appearance="outline">
                      <mat-label>42 - Qtde.</mat-label>
                      <input matInput type="text" (keyup)="onChangeTotalValue()"
                        [maxlength]="spSadtFieldsMaxLengthEnum.procedureCount" minimun="1"
                        formControlName="procedureCount" (input)="inputNumberMinOne('procedureCount')">
                        @if (model.get('procedureCount').invalid && !model.get('procedureCount').errors?.maxlength) {
                          <mat-error
                            >Preenchimento
                          incorreto</mat-error>
                        }
                        <mat-hint align="end">{{ model.get('procedureCount').value ?
                          model.get('procedureCount').value.length : 0
                        }}/{{spSadtFieldsMaxLengthEnum.procedureCount}}</mat-hint>
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-4 col-md-3">
                      <mat-form-field appearance="outline">
                        <mat-label>43 - Via</mat-label>
                        <mat-select formControlName="idAccess" (selectionChange)="onChangeAccess()">
                          <mat-option ngValue="null">Selecione</mat-option>
                          @for (item of accessMap | keyvalue; track item) {
                            <mat-option
                              [value]="item.key">{{item.value.accessLookupCode}} - {{item.value.accessDescription}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (model.get('idAccess').invalid) {
                          <mat-error>Preenchimento incorreto</mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-4 col-md-3">
                      <mat-form-field appearance="outline">
                        <mat-label>44 - Tec.</mat-label>
                        <mat-select formControlName="idTechnique">
                          <mat-option ngValue="null">Selecione</mat-option>
                          @for (item of techniqueMap | keyvalue; track item) {
                            <mat-option
                              [value]="item.key">{{item.value.techniqueLookupCode}} - {{item.value.techniqueDescription}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (model.get('idTechnique').invalid) {
                          <mat-error>Preenchimento incorreto</mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-2 col-md-3">
                      <mat-form-field appearance="outline">
                        <mat-label>45 - Fator Red/Acresc.</mat-label>
                        <input matInput type="text" formControlName="adjustmentCoefficient" currencyMask
                          [options]="{ inputMode: 'Natural', prefix: '', decimal: '.', max: '9.99', min: '0.01', allowNegative: 'false' }"
                          (keyup)="onChangeTotalValue()">
                          @if (model.get('adjustmentCoefficient').invalid && !model.get('adjustmentCoefficient').errors?.maxlength) {
                            <mat-error
                              >Preenchimento
                            incorreto</mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-12 col-sm-6 col-md-3">
                        <mat-form-field appearance="outline">
                          <mat-label>46 - Valor Unitário (R$)</mat-label>
                          <input matInput type="text" formControlName="procedureUnitValue" currencyMask
                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', max: '999999.99', allowNegative: 'false' }"
                            (keyup)="onChangeTotalValue()">
                            @if (model.get('procedureUnitValue').invalid && !model.get('procedureUnitValue').errors?.maxlength) {
                              <mat-error
                                >Preenchimento
                              incorreto</mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-3">
                          <mat-form-field appearance="outline">
                            <mat-label>47 - Valor Total (R$)</mat-label>
                            <input matInput type="text" formControlName="procedureTotalValue" currencyMask
                              [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', max: '999999.99', allowNegative: 'false' }">
                              @if (model.get('procedureTotalValue').invalid && !model.get('procedureTotalValue').errors?.maxlength) {
                                <mat-error
                                  >Preenchimento
                                incorreto</mat-error>
                              }
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="title-header">
                          <h1>Profissionais executantes</h1>
                        </div>
                        @for (item of professionals().controls; track item; let i = $index) {
                          <div class="row list-professionals"
                            formArrayName="listProfessionals">
                            <div class="row" [formGroupName]="i">
                              <div class="col-12 col-sm-6 col-md-3">
                                <mat-form-field appearance="outline">
                                  <mat-label>51 - Profissional</mat-label>
                                  <mat-select formControlName="professionalAgreement"
                                    (selectionChange)="selectProfessional($event,i)">
                                    <input class="inputSearchSelect" type="text"
                                      (keyup)="onKeyProfessional($event.target.value)" placeholder="Pesquisar"
                                      autocomplete="off" (keydown)="$event.stopPropagation()">
                                      @for (item of listProfessionalAgreementStruct; track item) {
                                        <mat-option
                                          [value]="item">{{item.nameProfessional}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                    @if (professionals().controls[i].get('professionalAgreement').invalid) {
                                      <mat-error
                                        >Preenchimento
                                      incorreto</mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3">
                                  <mat-form-field appearance="outline">
                                    <mat-label>49 - Grau de Part.</mat-label>
                                    <mat-select formControlName="idParticipationDegree">
                                      @for (item of participationDegreeMap | keyvalue; track item) {
                                        <mat-option
                                          [value]="item.key">{{item.value.participationDegreeLookupCode}} -
                                          {{item.value.participationDegreeDescription}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                    @if (professionals().controls[i].get('idParticipationDegree').invalid) {
                                      <mat-error
                                        >Preenchimento
                                      incorreto</mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3">
                                  <mat-form-field appearance="outline">
                                    <mat-label>50 - Cód. na Operadora/CPF</mat-label>
                                    <input matInput type="text" formControlName="professionalProviderCodeOrCpf">
                                    @if (professionals().controls[i].get('professionalProviderCodeOrCpf').invalid && !professionals().controls[i].get('professionalProviderCodeOrCpf').errors?.maxlength) {
                                      <mat-error
                                        >Preenchimento
                                      incorreto</mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3">
                                  <mat-form-field appearance="outline">
                                    <mat-label>55 - Cód. CBO</mat-label>
                                    <mat-select formControlName="idCbo">
                                      @for (item of cboMap | keyvalue; track item) {
                                        <mat-option
                                          [value]="item.key">{{item.value.cboCode}} -
                                          {{item.value.cboName}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                    @if (professionals().controls[i].get('idCbo').invalid) {
                                      <mat-error>Preenchimento
                                      incorreto</mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-6 col-md-5">
                                  <mat-form-field appearance="outline">
                                    <mat-label>52 - Conselho Profissional</mat-label>
                                    <mat-select matInput type="text" formControlName="idProfessionalCouncil">
                                      @for (item of listProfessionalCouncil; track item) {
                                        <mat-option
                                          [value]="item.idProfessionalCouncil">{{item.termCode}} - {{item.councilName}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-6 col-md-2">
                                  <mat-form-field appearance="outline">
                                    <mat-label>53 - N° no Conselho</mat-label>
                                    <input matInput type="text" formControlName="professionalCouncilCode">
                                    @if (professionals().controls[i].get('professionalCouncilCode').invalid && !professionals().controls[i].get('professionalCouncilCode').errors?.maxlength) {
                                      <mat-error
                                        >Preenchimento
                                      incorreto</mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-6 col-md-2">
                                  <mat-form-field appearance="outline">
                                    <mat-label>54 - UF</mat-label>
                                    <mat-select matInput type="text" formControlName="idCouncilState">
                                      @for (item of listState; track item) {
                                        <mat-option [value]="item.idState">{{item.stateCode}}
                                          - {{item.stateInitials}} / {{item.stateName}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                                @if (isEditingAllowed != null) {
                                  <div class="col-2">
                                    <button color="primary" mat-mini-fab type="button" (click)="addNext()"
                                      [disabled]="!this.isEditingAllowed">
                                      <mat-icon aria-hidden="false" aria-label="Menu apps">add</mat-icon>
                                    </button>
                                    @if (professionals().controls.length > 1) {
                                      <button color="primary" mat-mini-fab type="button" (click)="removeProfessional(i)"
                                        [disabled]="!this.isEditingAllowed">
                                        <mat-icon aria-hidden="false" aria-label="Menu apps">remove</mat-icon>
                                      </button>
                                    }
                                  </div>
                                }
                                @if (isEditingAllowed == null) {
                                  <div class="col-2">
                                    <button color="primary" mat-mini-fab type="button" (click)="addNext()">
                                      <mat-icon aria-hidden="false" aria-label="Menu apps">add</mat-icon>
                                    </button>
                                    @if (professionals().controls.length > 1) {
                                      <button color="primary" mat-mini-fab type="button" (click)="removeProfessional(i)"
                                        >
                                        <mat-icon aria-hidden="false" aria-label="Menu apps">remove</mat-icon>
                                      </button>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      </form>
                    }
                  </div>
                </div>
                <div mat-dialog-footer class="footer-modal">
                  <button mat-flat-button color="accent" class="btn-block" (click)="close()" type="button">
                    @if (!isLoading) {
                      <span>Cancelar</span>
                    }
                    @if (isLoading) {
                      <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                    }
                  </button>
                  @if (isEditingAllowed != null) {
                    <button form="fees-form" mat-flat-button type="submit" (click)="submit()"
                      color="primary" class="btn-block" [disabled]="!this.isEditingAllowed">
                      @if (!isLoading) {
                        <span>Salvar</span>
                      }
                      @if (isLoading) {
                        <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                      }
                    </button>
                  }
                </div>